import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAccountOwnerSummaryProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
  am?: Array<string>;
};
export type FetchAccountOwnerSummary = (filters: FetchAccountOwnerSummaryProps) => void;

const fetchAccountOwnerSummary = ({
  clusters = [],
  partners = [],
  origami,
  am = [],
}: FetchAccountOwnerSummaryProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
    account_manager: am.length ? "'" + am.join("','") + "'" : null,
  };
  await fetchReport("account_owner_summary", dispatch, params);
};

export default fetchAccountOwnerSummary;
